import { getProfileThumbnail } from "@shared/hooks/useProfile";
import { UserProfile } from "@shared/types/profile.types";
import { Link } from "react-router-dom";
import theme from "@shared/utils/themeColors";

interface MessagesHeaderProps {
  msgSidebarOpen: boolean;
  setMsgSidebarOpen: (open: boolean) => void;
  selectedUser: UserProfile | null;
  isTyping: { [key: string]: boolean };
}

function MessagesHeader({
  msgSidebarOpen,
  setMsgSidebarOpen,
  selectedUser,
  isTyping,
}: MessagesHeaderProps) {
  return (
    <div className="sticky top-0">
      <div className={`flex items-center justify-between before:absolute before:inset-0 before:backdrop-blur-md before:bg-gray-50/90 dark:before:bg-[#151D2C]/90 before:-z-10 border-b ${theme.border.primary} px-4 sm:px-6 md:px-5 h-16`}>
        {/* People */}
        <div className="flex items-center">
          {/* Close button */}
          <button
            className={`md:hidden text-gray-400 hover: ${theme.text.muted}`}
            onClick={() => setMsgSidebarOpen(!msgSidebarOpen)}
            aria-controls="messages-sidebar"
            aria-expanded={msgSidebarOpen}
          >
            <span className="sr-only">Close sidebar</span>
            <svg
              className="w-6 h-6 fill-current"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M10.7 18.7l1.4-1.4L7.8 13H20v-2H7.8l4.3-4.3-1.4-1.4L4 12z" />
            </svg>
          </button>
          {/* Selected user */}
          {selectedUser && (
            <>
              <div className="flex items-center">
                <img
                  className="rounded-full border-2 border-white dark:border-gray-800 box-content mr-2"
                  src={getProfileThumbnail(selectedUser)}
                  width="32"
                  height="32"
                  alt={selectedUser.name}
                />
                <div className="text-left">
                  <span className="text-sm font-semibold text-slate-800 dark:text-slate-100">
                    {selectedUser.name}
                  </span>

                  {Object.values(isTyping).some(Boolean) && (
                    <div className={`text-left text-xs ${theme.text.muted}`}>
                      Typing...
                    </div>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
        {/* Buttons on the right side */}
        {selectedUser && (
          <div className="flex">
            <Link
              to={"/community/profile/" + selectedUser.id}
              className={`p-1.5 shrink-0 rounded-lg ${theme.bg.primary} border ${theme.border.primary} hover:border-gray-300 dark:hover:border-gray-600 shadow-sm ml-2`}
            >
              <svg
                className={`fill-current text-gray-400 dark: ${theme.text.muted}`}
                width="16"
                height="16"
                viewBox="0 0 16 16"
              >
                <path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 12c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm1-3H7V4h2v5z" />
              </svg>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}

export default MessagesHeader;
